import Layout from "../../components/layout/Layout"

const PrivacyPolicyUA = () => {
    return (
        <div>
            <div className="container" style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 30 }}>
                <h2>Політика конфіденційності</h2>
                <p>Ми, Товариство з обмеженою відповідальністю “САНПОІНТ АЙ-ТІ СОЛЮШНС”, код ЄДРПОУ 42783354, відповідно до Закону України від 01 червня 2010 року № 2297-VI «Про захист персональних даних» (надалі – «Закон»), зобов’язуємось забезпечувати конфіденційність ваших персональних даних. Під персональними даними розуміються відомості, що дозволяють ідентифікувати вас, такі як ім’я, прізвище, електронна пошта, номер телефону та інші відомості, які ви добровільно надаєте нам.</p>

                <p>Компанія з великою повагою ставиться до конфіденційної (персональної) інформації всіх без винятку осіб, які відвідали Платформу, а також тих, хто користується наданими Платформою послугами. У зв’язку з цим, компанія прагне захищати конфіденційність персональних даних, створюючи і забезпечуючи максимально комфортні умови використання сервісів Платформи кожному користувачеві.</p>

                <p>Ця Політика конфіденційності описує, як ми збираємо, використовуємо та захищаємо вашу особисту інформацію під час використання нашої Платформи для управління проектами (далі – «Платформа»). Використовуючи Платформу, ви погоджуєтесь з умовами цієї Політики конфіденційності.</p>

                <h3>1. Збір та використання персональних даних</h3>
                <ol>
                    <li>
                        <p>Платформа збирає такі дані:</p>
                        <ul>
                            <li>Ім’я, прізвище, електронна пошта, номер телефону;</li>
                            <li>Інформація, яку Користувач надає добровільно (під час реєстрації, запитів).</li>
                        </ul>
                    </li>
                    <li>
                        <p>Цілі обробки даних:</p>
                        <ul>
                            <li>Надання доступу до Сервісу;</li>
                            <li>Технічна підтримка;</li>
                            <li>Інформування про новини та оновлення;</li>
                            <li>Аналітика для покращення якості послуг.</li>
                        </ul>
                    </li>
                </ol>

                <h3>2. Захист та зберігання даних</h3>
                <ol>
                    <li>Платформа забезпечує належний рівень захисту персональних даних Користувачів від несанкціонованого доступу, втрати або змін.</li>
                    <li>Термін зберігання: до моменту видалення профілю Користувача або припинення роботи Платформи.</li>
                </ol>

                <h3>3. Розкриття персональних даних</h3>
                <ol>
                    <li>
                        Платформа не передає персональні дані третім особам, за винятком випадків, коли дані можуть передаватися:
                        <ul>
                            <li>Платіжним системам для здійснення транзакцій;</li>
                            <li>Партнерам для обслуговування Платформи;</li>
                            <li>Уповноваженим органам відповідно до законодавства України.</li>
                        </ul>
                    </li>
                </ol>

                <h3>4. Використання файлів cookie</h3>
                <ol>
                    <li>Файли cookie застосовуються для збереження налаштувань Користувача, аналізу трафіку, покращення роботи Платформи.</li>
                    <li>Користувач може відмовитися від cookie у налаштуваннях браузера, але це може обмежити функціональність.</li>
                </ol>

                <h3>5. Права Користувачів</h3>
                <ol>
                    <li>
                        Користувач має право:
                        <ul>
                            <li>Доступу до своїх даних та їх зміни;</li>
                            <li>Обмеження обробки або видалення даних;</li>
                            <li>Запити подаються через контактну інформацію, зазначену нижче.</li>
                        </ul>
                    </li>
                </ol>

                <h3>6. Зміни до Політики</h3>
                <p>Платформа залишає за собою право змінювати Політику. Оновлення публікуються з датою набрання чинності. Продовження користування Платформою означає прийняття змін.</p>

                <h3>7. Контактна інформація</h3>
                <p>ТОВ “САНПОІНТ АЙ-ТІ СОЛЮШНС”<br />
                    Код ЄДРПОУ: 42783354<br />
                    Адреса: вул. Серпова 11, Київ, Україна<br />
                    Email: sktech@sunpoint.com.ua</p>

                <p>Дата останнього оновлення: 27.11.2024</p>
            </div>
        </div>
    )
}
export default PrivacyPolicyUA;